import '../../../scss/critical.scss';
import 'bootstrap/js/dist/collapse';
import '../../../scss/security.scss';

const $ = require('jquery');
global.$ = global.jQuery = $;

$(document).ready(function () {
    import(
        /* webpackMode: "eager" */
        '../qg-main'
    );
});
